import { useLayoutEffect, useRef } from "react"
import PropTypes from "prop-types"
import { ClickAwayListener } from "@mui/material"
import "./style.scss"

export default function Modal({ children, onClose, noButton, className, superModalOpened }) {
  const modalRef = useRef()
  useLayoutEffect(() => {
    const modal = modalRef.current
    modal.className = `${modal.className} modal-open`
  }, [])

  const handleOnclose = () => {
    if (!superModalOpened) {
      onClose()
    }
  }

  return <div ref={modalRef} className={`components_modal ${className}`}>
    <div className="modal-backdrop" />
    <div className="modal" role="dialog" aria-hidden="false" tabIndex="-1">
      <ClickAwayListener onClickAway={handleOnclose}>
        <div className="modal-dialog">
          {!noButton && <i className="close-button fa fa-close" onClick={onClose} />}
          <div className="modal-content">
            {children}
          </div>
        </div>
      </ClickAwayListener>
    </div>
  </div>
}

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  onClose: PropTypes.func.isRequired,
  noButton: PropTypes.bool,
  className: PropTypes.string,
  superModalOpened: PropTypes.bool,
}
